import {
    GET_PO_VENDOR_EMAIL,
    GET_SEND_PO_VENDOR_EMAIL
} from 'Store/AlertNotification/PoVendorEmail/PoVendorEmailType'
import AlertNotificationApiService from './AlertNotificationApiService'
import { setEmailAttachments, setPoVendorEmail, setSendPoVendorEmail } from 'Store/AlertNotification/PoVendorEmail/PoVendorEmailAction';
import { all, put, call, takeLatest } from 'redux-saga/effects'
import { API_URL, apiMethod, apiType, getFileName } from 'utils';
import { IPayload } from 'Model/IPayload';
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from '../AssetManagement/AssetManagementApiService'

function* getPoVendorEmailSaga(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.Notification,
            endpoint: `notification/povendoremail/${req?.payload?.poNumber}`,
            payload: null
        }

        const response = yield call(
            AlertNotificationApiService.post,
            API_URL.PostWebApp, payloadData

        );

        if (response) {
            yield put(setPoVendorEmail({ ...response, fleetRequestDetailId: req?.payload?.fleetRequestDetailId }));
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setPoVendorEmail({}))
        yield put(globalLoaderText(''))
    }
}

function* sendPoVendorEmailSaga(req: any): any {
    try {
        yield put(globalLoaderText("Sending Mail ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.Notification,
            endpoint: `notification/povendoremail`,
            payload: req?.payload
        }

        const response = yield call(
            AlertNotificationApiService.post,
            API_URL.PostWebApp, payloadData

        );

        if (response) {
            yield put(setSendPoVendorEmail({ ...response, fleetRequestDetailId: req?.payload?.fleetRequestDetailId }));
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setSendPoVendorEmail({
            isValid: false,
            validationMessage: 'Error occured while sending email',
            fleetRequestDetailId: req?.payload?.fleetRequestDetailId
        }))
        yield put(globalLoaderText(''))
    }
}

function* uploadEmailAttachments(req: any): any {
    try {
        yield put(globalLoaderText("Uploading Attachments...."));
        let fileObjList = req.attachmentList.formData;
        const list = req.attachmentList.filteredList;
        const CurrentAttachmentlist = req.attachmentList.list;

        fileObjList.append("apiMethod", apiMethod.POST)
        fileObjList.append("apiType", apiType.AssetManagement)
        fileObjList.append("endpoint", `assets/upload/attachments`)

        const response = yield call(AssetManagementApiService.post, `${API_URL.PostWebApp}/upload/attachments`, fileObjList);

        // Converting attachment URL to object
        const updatedResponse = response
            .map((x: string) => {
                const obj = list.find((y: any) => getFileName(x) === y.name);
                if (obj) {
                    return {
                        fileName: obj.name,
                        mimeType: obj.type,
                        attachmentUrl: x,
                    };
                }

                return null;
            })
            .filter((x: any) => !!x);
        yield put(globalLoaderText(""));
        yield put(setEmailAttachments([...CurrentAttachmentlist, ...updatedResponse]));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setEmailAttachments([]));
    }
}

function* watchergetTransferGridValue() {
    yield takeLatest(GET_PO_VENDOR_EMAIL, getPoVendorEmailSaga)
    yield takeLatest(GET_SEND_PO_VENDOR_EMAIL, sendPoVendorEmailSaga)
    yield takeLatest('UPLOAD_EMAIL_ATTACHMENTS', uploadEmailAttachments)
}

export default function* combinedSaga() {
    yield all([
        watchergetTransferGridValue()
    ])
}